import ReactPlayer from 'react-player'

import { Box, css } from '@mui/material'

import { CONFIG } from '../utils/config'
import { useMQ } from '../hooks/useMQ'
import VideoThumbnail from './images/video-thumbnail.png'
import { useCallback, useState } from 'react'

export function Video() {
  const { isXsSize, isSmSize, isMdSize } = useMQ()
  const [videoReady, setVideoReady] = useState(false)
  const [videoPlaying, setVideoPlaying] = useState(false)

  const getVideoHeight = () => {
    if (isXsSize) {
      return '300px'
    }
    if (isSmSize) {
      return '400px'
    }
    if (isMdSize) {
      return '600px'
    }

    return '676px'
  }

  const onVideoReady = useCallback(() => {
    setVideoReady(true)
    setVideoPlaying(true)
  }, [])

  const styles = {
    wrapper: css`
      margin-top: ${isSmSize ? '40px' : '120px'};
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    `,
    videoContainer: css`
      object-fit: cover;
      max-width: ${isXsSize || isSmSize || isMdSize ? '900px' : '1200px'};
      width: ${isXsSize || isSmSize || isMdSize ? '100%' : '1200px'};
      height: ${getVideoHeight()};
    `,
    videoThumbnail: css`
      object-fit: cover;
      width: 100%;
    `,
  }

  return (
    <Box css={styles.wrapper}>
      <Box
        css={styles.videoContainer}
        sx={{ overflow: 'hidden', borderRadius: '32px' }}
      >
        <ReactPlayer
          style={{
            display: videoReady ? 'block' : 'none',
            borderRadius: '32px',
            pointerEvents: 'none',
          }}
          url={CONFIG.youtubeVideo}
          width='100%'
          height='100%'
          loop={true}
          muted={true}
          playing={videoPlaying}
          onReady={onVideoReady}
        />
        {!videoReady && (
          <Box css={styles.videoContainer}>
            <img
              src={VideoThumbnail}
              css={styles.videoThumbnail}
              alt='Huma Video'
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}
